/**
 * Explore Catalog Service
 *
 * Fetches the tenant-specific Explore card catalog from the backend REST endpoint.
 */

import type { IHttpClient } from './httpClient'
import type { ExploreCatalogResponse } from '../types/explore.types'

/**
 * Public interface for the catalog service.
 * Implemented by the real HTTP service and replaceable with test doubles.
 */
export interface IExploreCatalogService {
  /**
   * Fetch the Explore card catalog for the given tenant.
   * @param tenantId - The tenant identifier from the auth session.
   */
  getCatalog(tenantId: string): Promise<ExploreCatalogResponse>
}

/**
 * Real HTTP implementation that calls GET /catalog?tenantId=<tenantId>.
 */
export class ExploreCatalogService implements IExploreCatalogService {
  constructor(private readonly httpClient: IHttpClient) {}

  async getCatalog(tenantId: string): Promise<ExploreCatalogResponse> {
    return this.httpClient.get<ExploreCatalogResponse>('/catalog', {
      params: { tenantId },
    })
  }
}
